import React from 'react'
import HomeComponent from '../components/HomeComponent'
import { Link } from 'react-router-dom';

import StudentCounter from '../components/studentCounter'
import TestimonialsData from '../components/testimonialsData';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';

import '../css/home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {EnquireForm} from '../components/EnquireForm';
import InstagramFeed from '../components/InstagramFeed';

import LocationOnIcon from '@material-ui/icons/LocationOn';

import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';

function home() {
  return (
    <div className='home-data'>

      <div className='hero-data'>
       <img src="../img/infa.webp"/>
       {/* <video src="/video/video.mp4" autoPlay muted loop /> */}
      </div>
 
      <div className='hero-form'>
        <div className='hero-box'>
          <EnquireForm/>
          {/* <div className='hero-from-name'>
            <h1>Enquire Now</h1>

            <div className='form-group'>
              <input type='text' placeholder="Enter Parents Name*"/>
            </div>
            <div className='form-group'>
              <input type='text' placeholder="Enter Student Name*"/>
            </div>
            <div className='form-group'>
              <input type='text' placeholder="Enter Parent Email Address"/>
            </div>
            <div className='form-group'>
              <input type='text' placeholder=" Enter  Mobile Number"/>
            </div>
            <div className='form-group'>
              <input type='text' placeholder=" Enter State"/>
            </div>
            <div className='form-group'>
              <input type='text' placeholder="Enter city"/>
            </div>
            <div className='form-group'>
            <div class="form-group">
                    <select class="form-cotrol" name="class" required="required">
                        <option value="" selected="selected">Select Class *</option>
                        <option value="Nur"> Nur</option>
                        <option value="K.G"> K.G</option>
                        <option value="I"> I</option>
                        <option value="II"> II</option>
                        <option value="III"> III</option>
                        <option value="IV"> IV</option>
                        <option value="V"> V</option>
                        <option value="VI"> VI</option>
                        <option value="VII"> VII</option>
                        <option value="VIII"> VIII</option>
                        <option value="IX"> IX</option>
                        <option value="X">X</option>
                        <option value="XI">XI</option>
                        <option value="XI">XII</option>
                    </select>
                </div>
            </div>
            <div class="form-group enqu_form_btn">
                    <button type="submit" class="btn btn-default enq_btn mybtnp myform-submit-btn1" name="getInTouch" value="getInTouch" id="myBtn">Submit</button>
                </div>
          </div> */}
        </div>
      </div>
   {/* <div className='school-program-box'>
      <div className='school-program'>
       <div className='school-program-img'> */}
        {/* <div className='program-inner-img'>
        <img src="../img/british-council.webp"/>
        </div>  */}
        {/* <div className='program-inner-img'>
        <img src="../img/ib-logo-new.webp"/>
        </div> 
        <div className='program-inner-img'>
        <img src="../img/pyp-programme-logo.webp"/>
        </div> 
        <div className='program-inner-img'>
        <img src="../img/new-cambridge.webp"/>
        </div> 
       </div> */}
       {/* <div className='cbse-btn'>
       <Link to="https://www.sanskarjaipur.com"> For CBSE Curriculum</Link>
       </div> */}
      {/* </div>
      </div> */}

     <div className='school-welcome-box'>
      <div className='left-side-box'>
      <h3>Welcome to</h3>
      <h2>Sanskar School</h2>
      <p>At Sanskar School, we offer our students high-quality education and shape bright futures through our world-class International Study Programmes.</p>
      <ul>
        <li>The International Baccalaureate Primary Years Programme (IB PYP)</li>
        <li>The International Baccalaureate Diploma Programme (IBDP)</li>
        <li>Cambridge Lower Secondary & Checkpoint</li>
        <li>Cambridge Upper Secondary (IGCSE)</li>
      </ul>
      <p>Sanskar is a nurturing and well-structured international school where mutual respect forms the foundation of all relationships, and rules are upheld consistently and fairly.</p>
      <p>We prioritize academic excellence, fostering each individual’s potential, and celebrating contributions to the broader community.</p>
      <p>Our students are encouraged to cultivate self-discipline, appreciate diverse achievements, and respect the values and beliefs of others. We guide them to develop a deeper understanding of themselves and others while finding meaning and purpose in their experiences.</p>
      <p>These values are at the heart of our policies and are exemplified by the attitudes and actions of our dedicated staff.</p>

    
 
      </div>
      <div className='right-side-box'>
        <div className='hero-about-img'>
          <img src='../img/school-ssembly2.webp'/>
        </div>
      {/* <div className='video-box'>
      <video  loop="true" autoplay="autoplay" controls muted>
      <source src="../img/video1.mp4" type="video/mp4"/>
      </video>
      </div> */}
      </div>
     </div>


    <div className='ssibsectionbxview'>
      <div className='school-landing-left'>
        <div className='landing-img-box'>
        <Link to="./about" state={{ scrollTo: 'MissionVision' }}>
          <img src="../img/school-ssembly.webp" alt=" "/>
          <div className='landing-img-heading'>
            <h1>The School Vision & Mission</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">The School Vision & Mission</h5>
                    {/* <span class="subheading">Mens Formal T-Shirt</span> */}
                  
          </div>
          <p>The School Vision & Mission</p>
          </Link>
        </div>
        <div className='landing-img-box'>
        <Link to="./pyp" state={{ scrollTo: 'IbpypCurriculum' }}>
        <img src="../img/Screenshot_38.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>IBPYP Curriculum</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">IBPYP Curriculum</h5>
                    {/* <span class="subheading">Mens Formal T-Shirt</span> */}
                  
          </div>
          </Link>
        </div>
      </div>  
      <div className='school-landing-left'>
      <div className='landing-img-box'>
      <Link to="./igcse"  state={{ scrollTo:'CieCurriculum' }}>
      <img src="../newimg/3.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>CIE Curriculum</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center"> Curriculum</h5>
                    {/* <span class="subheading">Mens Formal T-Shirt</span> */}
                
          </div>
          </Link>
        </div>
        <div className='landing-img-box'>
        <Link to="./ibdp" state={{ scrollTo:'IbdpCurriculum' }}>
        <img src="../img/Screenshot_5.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>IBDP Curriculum</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">IBDP Curriculum</h5>
                    {/* <span class="subheading">Mens Formal T-Shirt</span> */}
                 
          </div>
        </Link>
        </div>
      </div>
      <div className='school-landing-left'>
      <div className='landing-img-box'>
      <Link to="./about" state={{ scrollTo: 'SchoolDirector' }}>
        <img src="../img/rhea-thahryamal.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>Board of Governors</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Board of Governors</h5>
                    {/* <span class="subheading">Mens Formal T-Shirt</span> */}
                  
          </div>
          </Link>
        </div>
        <div className='landing-img-box'>
          <Link to="./Admission" state={{ scrollTo: 'OnlineRegistration' }}>
        <img src="../newimg/4.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>Admission</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Admission  </h5>
     
          </div>
        </Link>
        </div>
      </div>
      <div className='school-landing-left'>
        <div className='landing-img-onebox'>
        <Link to='./infra' state={{ scrollTo: 'SanskarInfrastructure' }} >
        <img src="../img/infa.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>Sanskar 
            Infrastructure</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Sanskar 
          Infrastructure</h5>
         
                 
          </div>
          </Link>
        </div>
      </div>
      <div className='school-landing-left'>
      <div className='landing-img-onebox'>
      <Link to='./sports' state={{ scrollTo: 'SanskarInfrastructure' }} >
        <img src="../newimg/competitive.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>Sports</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Sports</h5>
 
          </div>
          </Link>
        </div>
      </div>
      <div className='school-landing-left'>
      <div className='landing-img-box'>
      <Link to='./newsletter' state={{ scrollTo: 'SanskarNewsletter' }} >
      <img src="../newimg/7.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>Newsletter</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Newsletter</h5>
                
                 
          </div>
          </Link>
        </div>
        <div className='landing-img-box'>
        <Link to='./careercounselling' state={{ scrollTo: 'SanskarCounselling' }} >
        <img src="../newimg/studentex.webp" alt=""  />
        <div className='landing-img-heading'>

            <h1>Career-Counselling</h1>

          </div>
          <div className='landing-img-details'>
         
          <h5 class="card-title heading text-center">Career-Counselling</h5>
              
          </div>
          </Link>
        </div>
   
      </div>
      {/* <div className='school-landing-left'>
      <div className='landing-img-box'>
      <img src="../newimg/studentex.webp" alt=""/>
        <div className='landing-img-heading'>
            <h1>Alumni</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Alumni</h5>
  
                    <blockquote>
                   <p>Sanskar is a well ordered, caring international school in which relationships are based on mutual respect</p>
                    </blockquote>
          </div>
        </div>
        <div className='landing-img-box'>
        <img src="../newimg/11.webp" alt="" />
        <div className='landing-img-heading'>
        <h1>Calendar</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Calendar</h5>
             
                    <blockquote>
                   <p>Sanskar is a well ordered, caring international school in which relationships are based on mutual respect</p>
                    </blockquote>
          </div>
        </div>
      </div> */}
      {/* <div className='school-landing-left'>
      <div className='landing-img-box'>
        <img src="../img/Screenshot_38.webp" alt="" />
        <div className='landing-img-heading'>
            <h1>Result</h1>

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Result</h5>
         
                    <blockquote>
                   <p>Sanskar is a well ordered, caring international school in which relationships are based on mutual respect</p>
                    </blockquote>
          </div>
        </div>
        <div className='landing-img-box'>
        <img src="../newimg/Student-Council-Program.webp" alt=""/>
        <div className='landing-img-heading'>
        <h1>Career Guidence</h1>
            

          </div>
          <div className='landing-img-details'>
          <h5 class="card-title heading text-center">Calendar</h5>
          
                    <blockquote>
                   <p>Sanskar is a well ordered, caring international school in which relationships are based on mutual respect</p>
                    </blockquote>
          </div>
        </div>
      </div> */}
     
    </div> 



{/* 

     <div className='principal-desk-sec'>
      <div className='left-side'>
      <div className='img-box'>
      <img src="../img/Girdhar-Kumari2.webp"/>
      </div>
      </div>
      <div className='right-side'>
      <div className='content-box'>
        <h2>Principal’s Desk</h2>
        <p>“At Sanskar, we believe that the true goal of education is to build knowledge as well as character of our students by enabling them to think intensively and critically.” </p>
      <h3>Ms. Girdhar Kumari</h3>
      <p></p>
        </div>
      </div>
     </div> */}

     <div className='newsfeeds-sec'>
      <div className='newsfeeds-heading'>
        <h3><span>TRENDING</span> @ Sanskar School Jaipur</h3>
        <h1>NEWSFEED</h1>
        </div>

        <div className='newsfeeds-row'>
          <div className='news-left-box'>
          <div className='left-news-list'>
           <Link to='' >
            <img src='../img/we.webp'/>
            <div className='news-name'>
            <h5 className='news-heading'>Ms. Rhea Tharyamal, (Chairperson) receiving the 'Woman Entrepreneur of the Year 2024' award by Financial Express and IndusInd Bank.</h5>
        
            </div>
           </Link>
          </div>
          <div className='left-news-list'>
           <Link to='' >
            <img src='../img/CFoRE School Rankings award.webp'/>
            <div className='news-name'>
            <h5 className='news-heading'>Ms. Girdhar Kumari, Principal (International Curriculum), being awarded the prestigious Cfore School Rankings Award. We are beyond honored to receive this recognition.</h5>
     
            </div>
           </Link>
          </div>

          <div className='left-news-list'>
           <Link to='' >
            <img src='../img/High Happiness Quotient.webp'/>
            <div className='news-name'>
            <h5 className='news-heading' > Mrs. Neelam Bhardwaj, Principal (CBSE), receiving the Best School award under the category of ‘High Happiness Quotient’ in the North School Survey conducted by Education Today.</h5>
           
            </div>
           
           </Link>
          </div>
         
          
          </div>
          
          {/* <div className='news-right-box'>
          <div className='news-list'>
     
          <div className='news-img'><img src='../img/Graduation-Ceremony.webp'/></div>
          <div className='news-name'>
          <h5 className='news-heading'>Graduation Ceremony</h5>
            <p className='news-date'>03/02/2024</p>
          </div>
          </div>

          <div className='news-list'>

          <div className='news-img'><img src='../img/Graduation-Ceremony.webp'/></div>
          <div className='news-name'>
          <h5 className='news-heading'>Graduation Ceremony</h5>
            <p className='news-date'>03/02/2024</p>
          </div>
          </div>

          <div className='news-list'>

          <div className='news-img'><img src='../img/Graduation-Ceremony.webp'/></div>
          <div className='news-name'>
          <h5 className='news-heading'>Graduation Ceremony</h5>
            <p className='news-date'>03/02/2024</p>
          </div>
          </div>
   
         
         
        </div> */}
        </div>
        <div className='all-new-btn-box'>
        <Link to="./achievements"> view all</Link>
        </div>
     
     </div>

     {/* <div className='student-data'>
     <StudentCounter/>
     </div> */}

    <div className='nextstep'>
      <div className='nextstep-innerbox'>
      <div className='leftside'>
      <div className='img-box'>
      <img src='../img/ttns.webp'/>
      
      </div>
      </div>
      <div className='rightside'>
      <div className='rigth-side-innerbox'>
      <Link to="./contact">Enquiry <FontAwesomeIcon icon={faPaperPlane} /></Link>
      <Link to="./admission">Admission <FontAwesomeIcon icon={faFile} /></Link>
      <Link to="./contact">Get Direction <FontAwesomeIcon icon={faLocationDot}/> </Link>
      </div>
      </div>
    </div>
    </div>

    {/* <div className='open-admission'>
     <h2>Admission open for <span>for IBDP/IBCP 24-25</span></h2>
     <p>Get in touch with us to discuss:</p>
     <Link to="">+91 9876543210</Link>
  </div>*/}
     

     <div className='testimonials'>
     <h2>testimonials</h2>
     <TestimonialsData/>
     </div>

<div className='instagram-feed-sec'>

   <h1 className="text-2xl font-bold mb-4"> <InstagramIcon className='inst-feed-icon'/>sanskarjaipur</h1>
       

      <InstagramFeed />
<div className='followus-btn'>
        <Link to="https://www.instagram.com/sanskarjaipur">Follow Us</Link>
        </div>
     

    </div>


     {/*<HomeComponent/>*/  }
{/* <div class="call-btn">
    <div class="zoomIn"></div>
    <div class="pulse"></div>
    <div class="tada">
        <a href="tel:+91-8302507655">+91-8302507655</a>
    </div>
</div> */}

     {/* <div class="play-btn">
              <div class="call-btn2">
    <div class="zoomIn2"></div>
    <div class="pulse2"></div>
    <div class="tada2">
    <button class="play-button" onclick="showVideo()"> <a></a></button>
    </div>
</div>
            
              </div> */}


   



          
    </div>



  )
}

export default home
